import { render, staticRenderFns } from "./ReportLayout.vue?vue&type=template&id=01312da7&scoped=true&"
import script from "./ReportLayout.vue?vue&type=script&lang=js&"
export * from "./ReportLayout.vue?vue&type=script&lang=js&"
import style0 from "./ReportLayout.vue?vue&type=style&index=0&id=01312da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01312da7",
  null
  
)

export default component.exports